// extracted by mini-css-extract-plugin
export var animationAbsolute = "_30-q";
export var animationRelative = "_30-p";
export var backdropBlur = "_30-0";
export var detailLabelCell = "_30-12";
export var detailTable = "_30-11";
export var detailValueCell = "_30-13";
export var docIconBox = "_30-1d";
export var docIconBoxMd = "_30-1f";
export var docIconBoxSm = "_30-1e";
export var docTypeRow = "_30-16";
export var docTypeRowInner = "_30-17";
export var dropdownMatchDatePicker = "_30-3";
export var evidenceCardContent = "_30-1c";
export var fileUploadSpin = "_30-j";
export var gorgiasOpenButton = "_30-15 _30-d";
export var gorgiasTicketCard = "_30-14";
export var heroModalFooterButton = "_30-18";
export var hiddenContainer = "_30-o";
export var iconPrimary = "_30-1g";
export var iconSecondary = "_30-1h";
export var iconTertiary = "_30-1i";
export var integrationCard = "_30-1";
export var integrationLogoBox = "_30-2";
export var mainColumnSticky = "_30-1b";
export var maxWidthContainer = "_30-19";
export var modalContentBody = "_30-a";
export var modalHeaderImage = "_30-5";
export var modalImageLabel = "_30-7";
export var modalImageOverlay = "_30-6";
export var modalImageSubtitle = "_30-9";
export var modalImageTitle = "_30-8";
export var modalImageWrapper = "_30-4";
export var modalStickyFooter = "_30-b";
export var removeButton = "_30-e";
export var sidebarColumn = "_30-1a";
export var spinner = "_30-i";
export var timelineLine = "_30-y";
export var timelineLineBlack = "_30-10 _30-y";
export var timelineLineGray = "_30-z _30-y";
export var timelineLineHeight = "_30-x";
export var tlDotActivate = "_30-u";
export var tlDotActivateAnim = "_30-t";
export var tlDotHide = "_30-s";
export var tlDotHideAnim = "_30-r";
export var tlLineActivate = "_30-w";
export var tlLineActivateAnim = "_30-v";
export var uploadHint = "_30-n";
export var uploadIconBox = "_30-k";
export var uploadLabel = "_30-m";
export var uploadText = "_30-l";
export var uploadZone = "_30-f";
export var uploadZoneCursorDefault = "_30-h";
export var uploadZoneCursorPointer = "_30-g";
export var uploadedFileRow = "_30-c";
export var viewButton = "_30-d";